export var TipoProcessoReqEnum;
(function (TipoProcessoReqEnum) {
    TipoProcessoReqEnum["SAD"] = "SAD";
    TipoProcessoReqEnum["SIGADOC"] = "SIGADOC";
})(TipoProcessoReqEnum || (TipoProcessoReqEnum = {}));
(function (TipoProcessoReqEnum) {
    var mapDescricao = new Map([
        [TipoProcessoReqEnum.SAD, 'SAD'],
        [TipoProcessoReqEnum.SIGADOC, 'SIGADOC'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    TipoProcessoReqEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    TipoProcessoReqEnum.getOptions = getOptions;
})(TipoProcessoReqEnum || (TipoProcessoReqEnum = {}));
